'use client';

import React from 'react';

import {TopSection} from './TopSection';
import {BottomSection} from './BottomSection';
import {usePathname} from 'next/navigation';

export function LegacyFooter() {
  const pathname = usePathname();
  const hideFooter =
    pathname?.includes('/teaser') ||
    pathname?.includes('/launch') ||
    pathname?.includes('/logistics-centres') ||
    pathname?.includes('/tasareeh');

  if (hideFooter) return <></>;
  return (
    <>
      <TopSection />
      <BottomSection />
    </>
  );
}
